import React, { Suspense } from "react";
import { useDispatch, useSelector } from "react-redux";
import "semantic-ui-css/semantic.min.css";
import { Checkbox, Dropdown } from "semantic-ui-react";
import { toggleWindAlarmSensors } from "../../redux/shadingSystem";
import { setTurbineZoneShow } from "../../redux/windTurbine";
import "../NavBar.css";
import DropDownCustomized from "../dropDownComponent/DropDown";
import DropDownDaylight from "../dropDownComponent/DropDownDaylight";
import DropDownEnergyData from "../dropDownComponent/DropDownEnergyData";
import DropDownEnergyGeneration from "../dropDownComponent/DropDownEnergyGeneration";
import DropDownFloors from "../dropDownComponent/DropDownFloors";
import DropDownShading from "../dropDownComponent/DropDownShading";
import DropDownSunHours from "../dropDownComponent/DropDownSunHours";
import { getOldProjectId } from "../utility/hardconding";
import { reduxLocalStorage } from "../utility/storage";
import { updateFilter } from "../../redux/sceneGlobal";
import SoundEmissionDropdown from "./SoundEmissionDropdown";

export const sunsensors = [
  "sun hours",
  "direct energy",
  "diffuse energy",
  "global energy",
];

const NavBar = (props) => {
  var windRiskSelector = useSelector((state) => state.shadingSystem.value);
  const windAlarmSensors = useSelector(
    (state) => state.shadingSystem.windAlarmSensors,
  );
  var globalSceneValue = useSelector((state) => state.sceneVisibility.value);
  var windTurbineSelector = useSelector((state) => state.windTurbine.value);

  var surroundingSceneValue = useSelector(
    (state) => state.sceneVisibility.surroundingValue,
  );
  var solarSensorSelector = useSelector((state) => state.sensorSolars.value);
  var windDirectionSelector = useSelector((state) => state.windDirection.value);

  var allProejctParameters = useSelector((state) => state.sceneVar);
  var floors = allProejctParameters.floorsList;
  var winddirection = allProejctParameters.windDirectionList;
  var windRisk = allProejctParameters.windRisk;
  var energyValueData = allProejctParameters.energyValueList;
  const pvPanelsData = allProejctParameters.pvPanelsData;

  let daylightScenarioList = reduxLocalStorage.getItem(
    "daylight_scenario_list",
  );

  daylightScenarioList =
    daylightScenarioList === "null" || !daylightScenarioList
      ? []
      : daylightScenarioList
        ? daylightScenarioList.split(",")
        : [];

  const newProjectId = reduxLocalStorage.getItem("project_id");
  const project_id = getOldProjectId(newProjectId);
  // const project_id = reduxLocalStorage.getItem("project_id");

  const targetBuildingsList = [
    // { id: 0, title: "Target Building" },
    { id: 1, title: "External Walls" },
    { id: 2, title: "Internal Walls" },
    { id: 3, title: "Ceilings" },
    { id: 4, title: "Windows" },
    { id: 5, title: "Rooms" },
    { id: 6, title: "Doors" },
    { id: 7, title: "Stairs" },
    { id: 8, title: "Rooftops" },
    { id: 9, title: "PV Panels" },
  ];
  const surroundingList = [
    { id: 0, title: "Buildings" },
    { id: 1, title: "Infrastructure" },
    { id: 2, title: "Vegetation" },
    { id: 3, title: "Terrian" },
  ];

  // Layer visibility comes from project_info configs in allProejctParameters
  const hasShadingProgression = !!allProejctParameters?.shadingProgression;
  const shadingControlScenarios =
    allProejctParameters?.shadingControlScenarios ?? [];
  const hasShadingControl = shadingControlScenarios.length > 0;
  const hasSoundEmission = !!allProejctParameters?.soundEmission;

  const sensorPlacementZoneConfig =
    allProejctParameters?.sensorPlacementZoneConfig;
  const hasSensorCandidates =
    !!allProejctParameters?.sensorPlacement ||
    sensorPlacementZoneConfig?.length > 0;
  const sensorCandidates = (sensorPlacementZoneConfig ?? []).map((zone, i) => ({
    id: i + 3,
    title: zone,
    zone: i + 1,
  }));
  const hasWindRisk = !!windRisk;
  const showShadingData =
    hasSensorCandidates ||
    hasWindRisk ||
    hasShadingControl ||
    hasShadingProgression;

  const shadingProgressionItems = hasShadingProgression
    ? [{ id: 2, title: "Shading Progression" }]
    : [];

  const windTurbineZones = [{ id: 0, title: "Zone One" }];
  const dispatch = useDispatch();

  return (
    <Suspense fallback={<div>loading</div>}>
      <div className="NavBar">
        <Dropdown item simple text="Scene Selection" className="drop-down">
          <Dropdown.Menu>
            <DropDownCustomized
              key="target-building"
              inputData={targetBuildingsList}
              title="Target Building"
              status={globalSceneValue}
              value={props.value}
              floors="false"
              surroundings="false"
            />
            <DropDownCustomized
              key="surroundings"
              inputData={surroundingList}
              title="Surroundings"
              status={surroundingSceneValue}
              value={props.value}
              floors="false"
              surroundings="true"
            />
          </Dropdown.Menu>
        </Dropdown>
        {floors && <DropDownFloors data={floors} />}
        <Dropdown item simple text="virtual sensors" className="drop-down">
          <Dropdown.Menu>
            <DropDownSunHours
              inputData={sunsensors}
              title="Solar Sensors"
              status={solarSensorSelector}
              wind="false"
              parentTitle="virtual sensors"
            />
            {winddirection?.length > 0 && (
              <DropDownSunHours
                inputData={winddirection}
                title="Wind Sensors"
                status={windDirectionSelector}
                wind="true"
                parentTitle="virtual sensors"
              />
            )}
            <SoundEmissionDropdown
              projectId={newProjectId}
              enabled={hasSoundEmission}
            />
          </Dropdown.Menu>
        </Dropdown>

        {showShadingData && (
          <Dropdown item simple text="Shading data" className="drop-down">
            <Dropdown.Menu>
              {hasSensorCandidates && (
                <DropDownShading
                  inputData={sensorCandidates}
                  title="Sensor candidates"
                  status={windRiskSelector}
                  parentTitle="Shading data"
                />
              )}
              {hasWindRisk && (
                <DropDownShading
                  inputData={[{ id: 0, title: "Wind Risk Data" }]}
                  status={windRiskSelector}
                  parentTitle="Shading data"
                  flat
                />
              )}
              {hasShadingProgression && !hasShadingControl && (
                <DropDownShading
                  inputData={shadingProgressionItems}
                  status={windRiskSelector}
                  parentTitle="Shading data"
                  flat
                />
              )}
              {hasShadingControl && (
                <Dropdown
                  item
                  simple
                  text="Shading control"
                  className="drop-down"
                >
                  <Dropdown.Menu
                    className="kkk shading-control-scenarios"
                    style={{
                      transform: "translateY(-8px)",
                    }}
                  >
                    {shadingControlScenarios.map((scenario) => (
                      <Dropdown
                        key={scenario}
                        item
                        simple
                        text={scenario}
                        title={scenario}
                        className="drop-down truncate-label shading-control-scenario"
                      >
                        <Dropdown.Menu
                          className="kkk"
                          style={{ transform: "translateY(-8px)" }}
                        >
                          {hasShadingProgression && (
                            <DropDownShading
                              inputData={shadingProgressionItems}
                              status={windRiskSelector}
                              parentTitle={`Shading data >> Shading control >> ${scenario}`}
                              flat
                            />
                          )}
                          <Dropdown.Item
                            onClick={() => {
                              dispatch(toggleWindAlarmSensors(scenario));
                              dispatch(
                                updateFilter([
                                  `Shading data >> Shading control >> ${scenario} >> Wind alarm`,
                                ]),
                              );
                            }}
                          >
                            <Checkbox
                              label="Wind alarm"
                              checked={!!windAlarmSensors[scenario]}
                            />
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              )}
            </Dropdown.Menu>
          </Dropdown>
        )}
        {energyValueData ? (
          <Dropdown item simple text="Energy data" className="change-width">
            <Dropdown.Menu className="ggg">
              <Dropdown.Header content="Values" />

              {energyValueData.map((value, valueIndex) => {
                return (
                  <React.Fragment key={valueIndex}>
                    <DropDownEnergyData
                      data={value}
                      valueIndex={valueIndex}
                      parentTitle="Energy data"
                    />
                  </React.Fragment>
                );
              })}
            </Dropdown.Menu>
          </Dropdown>
        ) : null}

        {daylightScenarioList?.length > 0 && <DropDownDaylight />}

        {(pvPanelsData || Number(project_id) === 86) && (
          <Dropdown item simple text="Renewable Energy" className="drop-down">
            <Dropdown.Menu>
              {pvPanelsData && (
                <Dropdown item simple text="PV Yield" className="drop-down">
                  <Dropdown.Menu
                    className="kkk"
                    style={{
                      transform: "translateY(-8px)",
                    }}
                  >
                    {pvPanelsData?.map((zone) => {
                      return (
                        <DropDownEnergyGeneration zone={zone} key={zone} />
                      );
                    })}
                  </Dropdown.Menu>
                </Dropdown>
              )}

              {Number(project_id) === 86 && (
                <Dropdown item simple text="Wind Turbine" className="drop-down">
                  <Dropdown.Menu
                    className="kkk"
                    style={{
                      transform: "translateY(-8px)",
                    }}
                  >
                    {windTurbineZones.map((zone, zoneIndex) => {
                      const checked =
                        windTurbineSelector.checkStatus?.[zoneIndex];
                      return (
                        <Dropdown.Item
                          key={zoneIndex}
                          onClick={() => {
                            dispatch(setTurbineZoneShow([zoneIndex, !checked]));
                          }}
                        >
                          <Checkbox
                            label={zone.title}
                            key={zone.id + zone.title}
                            checked={checked}
                          />
                        </Dropdown.Item>
                      );
                    })}
                  </Dropdown.Menu>
                </Dropdown>
              )}
            </Dropdown.Menu>
          </Dropdown>
        )}
      </div>
    </Suspense>
  );
};

export default NavBar;
